import React, { useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

const InformasiTembusan = ({
  loading,
  input,
  setInput,
  dataIdamanUser,
  setIdamanUsers,
  setDataIdamanUser,
  openSnack,
  readOnly = false,
}) => {
  const [selectedValue, setSelectedValue] = useState({
    listKepadas: {},
    listTembusan: {},
  });

  const onAddListKepadas = (user) => {
    try {
      //console.log("ini ", user);
      if (!user?.email) throw "Pilih nama pegawai!";

      const isExists = input.listKepadas.find((dt) => dt.email === user.email);
      if (isExists) throw "User sudah dimasukkan";

      setInput((prev) => ({
        ...prev,
        listKepadas: [
          ...prev.listKepadas,
          {
            id: 0,
            seq: 0,
            userid: user.userId,
            email: user.email,
            nama: user.namalengkap,
            nopek: user.nopek,
            jabatanUser: user.jabatan,
            idLkp: input.idLkp,
          },
        ],
      }));
      setSelectedValue((prev) => ({ ...prev, listKepadas: {} }));
    } catch (error) {
      openSnack(error);
    }
  };

  const onAddListTembusan = (user) => {
    try {
      if (!user?.email) throw "Pilih nama pegawai!";

      const isExists = input.listTembusan.find((dt) => dt.email === user.email);
      if (isExists) throw "User sudah dimasukkan";

      setInput((prev) => ({
        ...prev,
        listTembusan: [
          ...prev.listTembusan,
          {
            id: 0,
            seq: 0,
            userid: user.userId,
            email: user.email,
            nama: user.namalengkap,
            nopek: user.nopek,
            jabatanUser: user.jabatan,
            idLkp: input.idLkp,
          },
        ],
      }));
      setSelectedValue((prev) => ({ ...prev, listTembusan: {} }));
    } catch (error) {
      openSnack(error);
    }
  };

  const onRemoveListKepadas = (user) => {
    let newList = input.listKepadas.filter((dt) => dt.email !== user.email);
    setInput((prev) => ({ ...prev, listKepadas: newList }));
  };

  const onRemoveListTembusan = (user) => {
    let newList = input.listTembusan.filter((dt) => dt.email !== user.email);
    setInput((prev) => ({ ...prev, listTembusan: newList }));
  };

  return (
    <>
      {/* LIST YTH */}
      <>
        <Box
          style={{
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 1,
            paddingBottom: 30,
            borderRadius: 10,
            display: "block",
            backgroundColor: "#fff",
          }}
        >
          <h3 style={{ textAlign: "left" }}>Informasi Kepada Yth</h3>
          <Grid container rowGap={1} columnGap={1}>
            <Grid item xl={4} lg={5} sm={12} xs={12}>
              <FormControl fullWidth>
                <Autocomplete
                  options={dataIdamanUser}
                  getOptionLabel={(opt) => opt?.namalengkap || ""}
                  renderInput={(params) => (
                    <TextField {...params} label="Ketik Nama Pegawai" />
                  )}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.defaultPrevented = true;
                      setIdamanUsers(e.target.value);
                    }
                  }}
                  value={selectedValue.listKepadas || ""}
                  onChange={(e, value) => {
                    setSelectedValue((prev) => ({
                      ...prev,
                      listKepadas: value,
                    }));
                    !value && setDataIdamanUser([]);
                  }}
                  noOptionsText="Type employee name and press enter to search"
                  loadingText="searching..."
                  loading={loading}
                  disabled={readOnly}
                />
              </FormControl>
            </Grid>
            <Grid item xl={3} lg={1} sm={3} xs={12}>
              <Button
                variant="contained"
                sx={{ fontSize: "1.5rem", height: "100%" }}
                onClick={() => onAddListKepadas(selectedValue.listKepadas)}
                disabled={readOnly}
              >
                +
              </Button>
            </Grid>
          </Grid>
          <Table>
            <TableHead>
              <TableCell>Nama Pegawai</TableCell>
              <TableCell>Nomor Pegawai</TableCell>
              <TableCell>Jabatan</TableCell>
              <TableCell></TableCell>
            </TableHead>
            <TableBody>
              {input.listKepadas?.map((dt, idx) => (
                <TableRow key={idx}>
                  <TableCell>{dt.nama}</TableCell>
                  <TableCell>{dt.nopek}</TableCell>
                  <TableCell>{dt.jabatanUser}</TableCell>
                  <TableCell>
                    <IconButton
                      color="primary"
                      component="label"
                      onClick={() => onRemoveListKepadas(dt)}
                      disabled={readOnly}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </>
      {/* LIST TEMBUSAN */}
      <>
        <Box
          style={{
            paddingLeft: 30,
            paddingRight: 30,
            paddingTop: 1,
            paddingBottom: 30,
            marginTop: 20,
            borderRadius: 10,
            display: "block",
            backgroundColor: "#fff",
          }}
        >
          <h3 style={{ textAlign: "left" }}>Informasi Tembusan</h3>
          <Grid container rowGap={1} columnGap={1}>
            <Grid item xl={4} lg={5} sm={12} xs={12}>
              <FormControl fullWidth>
                <Autocomplete
                  options={dataIdamanUser}
                  getOptionLabel={(opt) => opt?.namalengkap || ""}
                  renderInput={(params) => (
                    <TextField {...params} label="Ketik Nama Pegawai" />
                  )}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.defaultPrevented = true;
                      setIdamanUsers(e.target.value);
                    }
                  }}
                  value={selectedValue.listTembusan || ""}
                  onChange={(e, value) => {
                    setSelectedValue((prev) => ({
                      ...prev,
                      listTembusan: value,
                    }));
                    !value && setDataIdamanUser([]);
                  }}
                  noOptionsText="Type employee name and press enter to search"
                  loadingText="searching..."
                  loading={loading}
                  disabled={readOnly}
                />
              </FormControl>
            </Grid>
            <Grid item xl={3} lg={1} sm={3} xs={12}>
              <Button
                variant="contained"
                sx={{ fontSize: "1.5rem", height: "100%" }}
                onClick={() => onAddListTembusan(selectedValue.listTembusan)}
                disabled={readOnly}
              >
                +
              </Button>
            </Grid>
          </Grid>
          <Table>
            <TableHead>
              <TableCell>Nama Pegawai</TableCell>
              <TableCell>Nomor Pegawai</TableCell>
              <TableCell>Jabatan</TableCell>
              <TableCell></TableCell>
            </TableHead>
            <TableBody>
              {input.listTembusan?.map((dt, idx) => (
                <TableRow key={idx}>
                  <TableCell>{dt.nama}</TableCell>
                  <TableCell>{dt.nopek}</TableCell>
                  <TableCell>{dt.jabatanUser}</TableCell>
                  <TableCell>
                    <IconButton
                      color="primary"
                      component="label"
                      onClick={() => onRemoveListTembusan(dt)}
                      disabled={readOnly}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </>
    </>
  );
};

export default InformasiTembusan;
